// extracted by mini-css-extract-plugin
module.exports = {"list":"PublishErrors_list__1dlJ5","error":"PublishErrors_error__1fPet"};